import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
// 引入全局css
import './assets/scss/style.scss';
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';
const jnpf = require('./utils/jnpf').default

// import 'lib-flexible'
// import './utils/flexible.js'
//引入echart
//4.x 引用方式
import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

// 全局注册
Vue.component('icon', Icon);
Vue.use(dataV);

new Vue({
  router,
  store,
  data:function(){
  	  return{
  	      // api:'http://192.168.0.91:30000',    //测试
          // api:'http://10.80.21.21:30000'
  		  // api:'http://weicheng.jing7.net:8003',
          // api:'http://219.146.126.202:30000',
          // api:'https://dbzapi.sdvict.com',
          // api:'http://10.30.34.16:3000', //前置机
          // api:'http://127.0.0.1:30000'
          // api:'http://112.6.33.10:30000'  //滨州高新
          api:'http://222.134.9.198:30000'  //滨州滨城

      }
  },
  render: (h) => h(App),
}).$mount('#app');
